import React, { useState } from 'react';
import { Button, Card, Space, Typography, Upload, message } from 'antd';
import { UploadOutlined, DownloadOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { customerService } from '../services/customers';

const { Title, Text } = Typography;

export const CustomerImport: React.FC = () => {
  const [importing, setImporting] = useState(false);
  const navigate = useNavigate();

  const downloadBlob = (blob: Blob, filename: string) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleImport = async (file: File) => {
    setImporting(true);
    try {
      await customerService.import(file);
      message.success('Personal import completed');
    } catch {
      message.error('Failed to import personal data');
    } finally {
      setImporting(false);
    }
    return false;
  };

  const handleDownloadTemplate = async () => {
    try {
      const blob = await customerService.downloadImportTemplate();
      downloadBlob(blob, 'personal-import-template.xlsx');
    } catch {
      message.error('Failed to download personal import template');
    }
  };

  return (
    <div>
      <Space
        style={{
          marginBottom: 16,
          width: '100%',
          justifyContent: 'flex-end',
        }}
      >
        <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/customers')}>
          Back
        </Button>
      </Space>
      <Card>
        <Space direction="vertical" size={16} style={{ width: '100%' }}>
          <Title level={3} style={{ margin: 0 }}>
            Personal Import
          </Title>
          <Text>
            Upload an Excel file to import personal records. Use the template to match required columns.
          </Text>
          <Space>
            <Upload
              accept=".xlsx,.xls"
              showUploadList={false}
              beforeUpload={(file) => {
                void handleImport(file);
                return false;
              }}
            >
              <Button type="primary" icon={<UploadOutlined />} loading={importing}>
                Upload File
              </Button>
            </Upload>
            <Button icon={<DownloadOutlined />} onClick={handleDownloadTemplate}>
              Personal Import Template
            </Button>
          </Space>
        </Space>
      </Card>
    </div>
  );
};
